module.exports = __webpack_public_path__ + "static/media/marker-new.70ac9792.svg";